var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-bookmarks",
    },
    [
      _c(
        "ul",
        {
          staticClass: "cw-tiles",
        },
        _vm._l(_vm.sortedBookmarks, function (bookmark) {
          return _c(
            "li",
            {
              key: bookmark.id,
              staticClass: "tile",
              class: [
                bookmark.attributes.payload.color,
                _vm.sortedBookmarks.length > 3 ? "" : "cw-tile-margin",
              ],
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.getElementUrl(bookmark),
                    title: bookmark.attributes.title,
                  },
                },
                [
                  _c("div", {
                    staticClass: "preview-image",
                    class: [_vm.hasImage(bookmark) ? "" : "default-image"],
                    style: _vm.getChildStyle(bookmark),
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "description",
                    },
                    [
                      _c("header", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(bookmark.attributes.title) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "description-text-wrapper",
                        },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(bookmark.attributes.payload.description)
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("footer", [
                        bookmark.relationships.course
                          ? _c(
                              "span",
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "seminar",
                                    role: "info_alt",
                                  },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getCourseName(
                                        bookmark.relationships.course.data.id
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        bookmark.relationships.user
                          ? _c(
                              "span",
                              [
                                _c("studip-icon", {
                                  attrs: {
                                    shape: "content2",
                                    role: "info_alt",
                                  },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$gettext("Arbeitsplatz")) +
                                    "\n                        "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }